import React from 'react';

import { Pill, Label } from './NewBadge.styles';

export type NewBadgeProps = {
  /** Compact variant for the mobile 70px theme tiles. */
  small?: boolean;
};

/** "New" pill shown on a theme the CMS badges as new (see `Theme.isNew`). */
export const NewBadge = ({ small = false }: NewBadgeProps): React.ReactElement => (
  <Pill $small={small}>
    <Label text="New" tag="span" $small={small} />
  </Pill>
);

export default NewBadge;
